<template>
  <div class="w-full height-100">
    <el-dialog title="" :visible.sync="isShowadmin" width="30%">
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">
          {{ PopUpheader }}
        </h3></template
      >
      <div>
        <div class="">
          <div class="relative">
            <small class="fsize12 bg-white text-dark font-semibold"
              >User Name
            </small>
            <el-input
              v-model="name"
              placeholder="Enter..."
              maxlength="50"
              class="rounded-xl mt-2"
              :disabled="!isNewAdmin"
            />
          </div>

          <div class="relative mt-4">
            <small class="fsize12 bg-white text-dark font-semibold"
              >Phone Number</small
            >
            <el-input
              v-model="mobile"
              type="text"
              placeholder="Enter..."
              class="rounded-xl mt-2"
              :disabled="!isNewAdmin"
              :maxlength="10"
              @input="validateNumber"
            />
          </div>
          <div class="relative mt-4">
            <small class="fsize12 bg-white text-dark font-semibold"
              >Email
            </small>
            <el-input
              v-model="email"
              type="email"
              placeholder="Enter..."
              class="rounded-xl mt-2"
              maxlength="50"
              @blur="validateEmail"
              :disabled="!isNewAdmin"
            />
          </div>
          <p v-if="isValidEmail">invalid email</p>

          <div class="relative mt-4">
            <small class="fsize12 bg-white text-dark font-semibold">Role</small>
            <el-select
              v-model="role"
              placeholder="Select"
              popper-class="z-index-option"
            >
              <el-option
                v-for="role in roles"
                :key="role._id"
                :label="role.name"
                :value="role._id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="mt-4">
            <label>Status</label>
            <div class="flex items-center gap-2 mt-2">
              <el-radio-group v-model="radio">
                <el-radio :label="true">Active</el-radio>
                <el-radio :label="false">Inactive</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="flex justify-center">
          <vs-button
            v-if="isNewAdmin"
            type="primary"
            class="bg-primary rounded-lg cursor-pointer w-full mt-8 px-8 py-3"
            @click="addAdmin"
            :disabled="disableButtonValidation"
            >Submit</vs-button
          >
          <vs-button
            v-if="!isNewAdmin"
            type="success"
            class="cursor-pointer rounded-lg mt-8 px-8 py-3 w-full bg-success"
            @click="editUserAdmin"
            >Update</vs-button
          >
        </div>
      </div>
    </el-dialog>

    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Admin Management
          </h2>
        </div>
      </div>
    </div>

    <div class="bg-white p-6 menucontrol-scroll fixed-top">
      <div class="flex mt-4">
        <div class="w-10/12 relative">
          <el-input
            placeholder="Search"
            v-model="search"
            maxlength="50"
            class="w-full"
          ></el-input>
          <div class="absolute top-0 mr-2 mt-2 bg-white cursor-pointer right-0">
            <feather-icon
              icon="SearchIcon"
              @click="getAdmins"
              SvgClasses="w-4 h-4"
            />
          </div>
        </div>
        <div class="w-2/12 flex justify-end mb-4" @click="popupwindow">
          <vs-button type="primary" class="bg-primary rounded-lg px-10 py-3"
            >Add</vs-button
          >
        </div>
      </div>
      <div>
        <el-table
          :data="admins"
          border
          style="width: 100%"
          class="table-responsive table-flush mt-4 cust-overflow-x-primary-color"
          header-row-class-name="thead-light table-th-colorpd"
        >
          <el-table-column prop="name" label="User Name" min-width="50px">
          </el-table-column>
          <el-table-column prop="mobile" label="Phone Number" min-width="50px">
          </el-table-column>
          <el-table-column prop="email" label="Email" min-width="50px">
          </el-table-column>
          <el-table-column prop="isActive" label="Active" min-width="20px">
            <template v-slot="{ row }">
              {{ row.isActive }}
            </template>
          </el-table-column>

          <el-table-column prop="role" label="Role" min-width="50px">
            <template v-slot="{ row }">
              {{ row.roles.length ? row.roles[0].name : row.role }}
            </template>
          </el-table-column>

          <el-table-column
            v-if="login.role == 'Admin'"
            prop="city"
            label="Actions"
            min-width="40px"
          >
            <template v-slot="{ row }">
              <div class="flex gap-1 items-center">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-4 h-4"
                  class="cursor-pointer"
                  @click="editAdmin(row)"
                />
                <feather-icon
                  @click="deleteAdmin(row)"
                  icon="TrashIcon"
                  svgClasses="w-4 h-4 text-danger"
                  class="cursor-pointer"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="w-full flex justify-end mt-6">
          <!-- <el-pagination
            background
            layout="prev,pager,next"
            :total="1000"
          ></el-pagination> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      isShowadmin: false,
      admins: [],
      search: "",
      name: "",
      isValidEmail: false,
      email: "",
      mobile: "",
      role: "",
      roles: [],
      radio: false,
      isNewAdmin: true,
      admindata: [],
      PopUpheader: "",
    };
  },
  computed: {
    ...mapState("admin", ["login"]),
    disableButtonValidation() {
      if (this.isValidEmail == false) {
        if (
          this.name == "" ||
          this.email == "" ||
          this.mobile == "" ||
          this.role == ""
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
  },
  methods: {
    validateEmail() {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9,-]+\.[a-zA-Z]{2,}$/;
      if (emailRegex.test(this.email)) {
        this.isValidEmail = false;
      } else {
        this.isValidEmail = true;
      }
    },

    popupwindow() {
      this.PopUpheader = "Add Admin";
      this.isShowadmin = true;
      this.isNewAdmin = true;
    },
    async getAdmins() {
      let payload = {};
      if (this.search != "") {
        Object.assign(payload, { search: this.search });
      }
      const { data } = await this.$store.dispatch("admin/getAdmins", payload);
      this.admins = data.data.admins;
    },

    async getRoles() {
      const { data } = await this.$store.dispatch("admin/getRoles");
      this.roles = data.data;
    },

    async addAdmin() {
      await this.$store.dispatch("admin/addAdmin", {
        name: this.name,
        email: this.email,
        mobile: this.mobile,
        role: this.role,
      });
      this.isShowadmin = false;
      await this.getAdmins();
    },
    validateNumber() {
      let a = this.mobile.replace(/\D/g, "");
      this.mobile = a;
    },

    async deleteAdmin(item) {
      this.$swal({
        icon: "info",
        title: "Are you sure?",
        showCancelButton: true,
        confirmButtonColor: "#ea4dff",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.$store.dispatch("admin/deleteAdmins", { _id: item._id });
          await this.getAdmins();
        }
      });
    },
    async editAdmin(admindata) {
      this.isNewAdmin = false;
      this.admindata = admindata;
      this.PopUpheader = "Edit Admin";
      this.name = admindata.name;
      this.email = admindata.email;
      this.mobile = admindata.mobile;
      this.role = admindata.role._id;
      this.radio = admindata.isActive;
      this.isShowadmin = true;
    },
    async editUserAdmin() {
      await this.$store.dispatch("admin/editUserAsAdmin", {
        id: this.admindata._id,
        role: this.role,
        status: this.radio,
      });
      this.isShowadmin = false;
      await this.getAdmins();
    },
  },

  watch: {
    isShowadmin(newValue) {
      if (!newValue) {
        this.name = "";
        this.email = "";
        this.mobile = "";
        this.role = "";
      }
    },
    search(newVal) {
      this.getAdmins();
    },
  },

  mounted() {
    this.getAdmins();
    this.getRoles();
  },
};
</script>
